<script lang="ts">
  import { createEventDispatcher } from 'svelte';
  import { page } from '$app/stores';
  import OAuthButton from '$components/OAuthButton.svelte';
  import { analytics } from '$lib/utils';
  import { EOETracking } from '$lib/tracking';

  export let type = 'login';

  const dispatch = createEventDispatcher();

  // Google OAuth doesn't work with TikTok's in-app browser -- 9th, June, 2022.
  const isTikTokBrowser = /ByteDance|ByteLo/.test($page.data.userAgent);
</script>

<div class="flex justify-start space-x-3">
  {#if !isTikTokBrowser}
    <OAuthButton
      on:click={() => analytics.track({ name: EOETracking.stepOneTracking.TRACK_GOOGLE })}
      provider="google"
      {type}
      transparent
      on:needsOtp
      on:success={() => dispatch('after')}
    />
  {/if}
  <OAuthButton
    on:click={() => analytics.track({ name: EOETracking.stepOneTracking.TRACK_DISCORD })}
    provider="discord"
    {type}
    transparent
    on:needsOtp
    on:success={() => dispatch('after')}
  />
  <OAuthButton
    on:click={() => analytics.track({ name: EOETracking.stepOneTracking.TRACK_TWITCH })}
    provider="twitch"
    {type}
    transparent
    on:needsOtp
    on:success={() => dispatch('after')}
  />
  <OAuthButton
    on:click={() => analytics.track({ name: 'EOE Application 01 - Facebook' })}
    provider="facebook"
    {type}
    transparent
    on:needsOtp
    on:success={() => dispatch('after')}
  />
  <OAuthButton
    on:click={() => analytics.track({ name: EOETracking.stepOneTracking.TRACK_APPLE })}
    provider="apple"
    {type}
    transparent
    on:needsOtp
    on:success={() => dispatch('after')}
  />
</div>
